import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BOM_USERS_API } from "../apiRoutes";

interface UseGetBOMUsersListProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBOMUsersList = async (communityId: string) =>
  await axiosAuth.get(`${BOM_USERS_API}?communityId=${communityId}`);

const useGetBOMUsersList = ({
  communityId,
  queryParams,
}: UseGetBOMUsersListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bomUsersList", communityId],
    queryFn: () => getBOMUsersList(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetBOMUsersList;
